import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { FC, useContext, useEffect } from 'react'

import { CenteredLoading } from '../../components'
import { CustomerPortalAppBar } from '../../components/SharedUICustomerPortal/CustomerPortalAppBar'
import { PaymentPortalContext } from '../../providers/PaymentPortalProvider/PaymentPortalProvider'
import DesktopPortalBody from './DesktopPortalBody'
import MobilePortalBody from './MobilePortalBody'

const PaymentPortal: FC = () => {
  const theme = useTheme()
  const hasDesktopWidth = useMediaQuery(theme.breakpoints.up('md'))

  const { isLoading, shop } = useContext(PaymentPortalContext)

  useEffect(() => {
    document.title = 'InTune Auto - Payment Portal'
  })

  const getBodyContent = () => {
    if (isLoading) {
      return <CenteredLoading />
    } else if (hasDesktopWidth) {
      return <DesktopPortalBody />
    } else {
      return <MobilePortalBody />
    }
  }

  return (
    <>
      {shop && <CustomerPortalAppBar shop={shop} />}
      <Stack spacing={2} padding={2}>
        <Typography variant="h1">Payment Portal</Typography>
        <Typography>
          Review authorized services and pay with a credit card
        </Typography>
        {getBodyContent()}
      </Stack>
    </>
  )
}

export default PaymentPortal
